import JotformEmbed from 'react-jotform-embed';

function Jdocup() {
  return (
      <JotformEmbed src="https://form.jotform.com/223437728323053" />
  );
}

export default Jdocup;
